// @flow

import { type Address } from './types';
import { getZipcode } from './get-zipcode';
import { getState } from './get-state';
import { getCity } from './get-city';
import { getStreetName } from './get-street-name';
import { getStreetNumber } from './get-street-number';

export function isEmpty(address: ?Address): boolean {
  return !address ||
    (!getZipcode(address)
     && !getState(address)
     && !getCity(address)
     && !getStreetName(address)
     && !getStreetNumber(address)
    );
}
